import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './index.module.scss';

const Alert = ({ className, text, type }) => (
  <div
    className={classnames(styles.container, className, {
      [styles.error]: type === 'error',
      [styles.info]: type === 'info',
      [styles.warning]: type === 'warning',
    })}
  >
    {text}
  </div>
);

Alert.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.oneOf(['error', 'info', 'warning']),
};

export default Alert;
